/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { CustomCategoryPage } from '@/components/layouts/CustomCategoryPage';
import { CustomSimpleTemplate } from '@/components/layouts/CustomSimpleTemplate';
import { CustomTemplate } from '@/components/layouts/CustomTemplate';
import { MyPages } from '@/components/layouts/MyPages';
import { TwoColumn } from '@/components/layouts/TwoColumn';
import { Layout } from '@/data/types/Layout';
import { FC } from 'react';

export const layoutManifestCustom: {
	[key: string]: FC<{ layout: Layout }>;
} = {
	CustomTemplate,
	CustomSimpleTemplate,
	CustomCategoryPage,
	TwoColumn,
	MyPages,
};
